export default "__VITE_ASSET__DF3d$tTw__"